var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('audio',{ref:"audio",staticClass:"audio",attrs:{"controls":""}},[_c('source',{attrs:{"src":require("../static/notice.mp3")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }